import styled, { css } from 'styled-components'

import Link from './link'
import { getThemeColor, styledLink } from '../utils/styles'

const StyledComponentLink = styled(Link)`
  ${styledLink};
  text-decoration: none;

  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `}

  ${(props) =>
    props.colorPrimary &&
    css`
      color: ${getThemeColor('vividPrimary')};
    `};
`

export default StyledComponentLink
